import { Button, Modal } from '@economic/gaudi';
import React from 'react';
import { Form } from '../../../../shared/components/Form';
import { t } from '../../../../shared/components/l10n/l10n';
import internalApiClient from '../../../../shared/util/api/internalApiClient';
import { formatRegistration, InterestAreas } from './util';
import { WizardCheckbox } from './Wizard/WizardCheckbox';

export const InterestAreasModel = ({ data, refresh }) => {
    const onSubmit = async values => {
        try {
            const response = await internalApiClient.put(`/user-panel`, formatRegistration(values));
            refresh();

            return Promise.resolve(response);
        } catch (error) {
            if (error.response && error.response.data) {
                error.validation = error.response.data;
            }

            return Promise.reject(error);
        }
    };

    return (
        <Form initialData={data} onSubmit={onSubmit} onSubmitted={() => {}}>
            {({ handleSubmit, values }) => {
                return (
                    <>
                        <Modal.Header>{t`USER_PANEL_AREASOFINTEREST`}</Modal.Header>
                        <Modal.Content>
                            <div className="pt-6">
                                {Object.keys(InterestAreas).map(key => {
                                    return (
                                        <React.Fragment key={key}>
                                            <WizardCheckbox
                                                text={t(InterestAreas[key])}
                                                name={`interestAreas.${key}`}
                                                checked={values.interestAreas && values.interestAreas[key]}
                                                fieldClassName="w-full"
                                            />
                                        </React.Fragment>
                                    );
                                })}
                            </div>
                        </Modal.Content>
                        <Modal.Footer>
                            <Button
                                appearance="primary"
                                onClick={() => {
                                    handleSubmit(values);
                                }}>{t`BUTTON_SAVE`}</Button>
                        </Modal.Footer>
                    </>
                );
            }}
        </Form>
    );
};
